import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    departaments: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_DEPARTAMENT_SELECT_IDS (store, ids) {
      store.departaments.selectIds = ids
    },
    REMOVE_DEPARTAMENT_SELECT_IDS (store, ids) {
      store.departaments.selectIds = store.departaments.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_DEPARTAMENT_SELECT_ID (store, id) {
      store.departaments.selectId = id
    },
    SET_DEPARTAMENT_FILTERS (store, filters) {
      store.departaments.filters = filters
    },
    SET_DEPARTAMENT_PAGINATE (store, val) {
      store.departaments.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getDepartaments: (store, getters) => {
      return store.departaments.selectIds.map((id) => {
        return getters['entities/departaments/find'](id)
      })
    },
    getDepartamentsFilters: (store, getters) => {
      return store.departaments.filters
    },
    getDepartamentsPaginate: (store, getters) => {
      return store.departaments.paginate
    },
    getDepartament: (store, getters) => {
      return getters['entities/departaments/find'](store.departaments.selectId) || {}
    }
  },
  actions: {
    /*
    selectDepartaments
    */
    selectDepartaments ({commit, dispatch, getters, state}, filters) {
      return dispatch('getDepartaments', filters)
      .then((response) => {
        commit('SET_DEPARTAMENT_FILTERS', filters)
        commit('SET_DEPARTAMENT_PAGINATE', response)
        commit('SET_DEPARTAMENT_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectDepartaments
    */
    refreshSelectDepartaments ({commit, dispatch, getters, state}) {
      return dispatch('selectDepartaments', getters.getDepartamentsFilters)
    },
    /*
    selectDepartament
    */
    selectDepartament ({commit, dispatch, getters, state}, id) {
      return dispatch('getDepartamentById', id)
      .then((response) => {
        commit('SET_DEPARTAMENT_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getDepartaments
    */
    getDepartaments ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/departaments`, {params: filters})
      .then((response) => {
        return dispatch('entities/departaments/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.departaments || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getDepartamentById
    */
    getDepartamentById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/departaments/${id}`)
      .then((response) => {
        return dispatch('entities/departaments/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.departaments[0]
      })
    },
    /*
    createDepartament
    */
    createDepartament ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/departaments`, data)
      .then((response) => {
        return dispatch('entities/departaments/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.departaments[0]
      })
    },
    /*
    updateDepartament
    */
    updateDepartament ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/departaments/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/departaments/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.departaments[0]
      })
    },
    /*
    mergeDepartaments
    */
    mergeDepartaments ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/departaments/merge`, data)
      .then((response) => {
        return dispatch('entities/departaments/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.departaments[0]
      })
    },
    /*
    deleteDepartament
    */
    deleteDepartament ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/departaments/${id}`)
      .then((response) => {
        commit('REMOVE_DEPARTAMENT_SELECT_IDS', [id])
        dispatch('entities/departaments/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Departament.js